import { TranslationMap } from '@trimble-gcs/i18n-types';

export function scandataListTranslations() {
  return {
    error: {
      text: $localize`:@@scandataList.error:Error loading data. Please try again later.`,
      desc: 'Error message displayed when data for the List View could not be loaded.',
    },
  } satisfies TranslationMap;
}
